import { useState, useContext, useEffect } from "react";
import { AuthContext } from "context/AuthContext";
import { APIProvider } from "@vis.gl/react-google-maps";
import CropAlertImgForSearchModal from "ui/alerts/img-search/img-crop-for-search-modal";
import ImgSearchModal from "./img-search-modal";

export type FilterType = {
  siteIds?: number[];
  startedAt?: Date;
  endedAt?: Date;
};

export default function ImgSearchModalControl({
  title,
  defaultImgUrl,
  isOpen,
  onRequestClose,
}: {
  title?: string;
  defaultImgUrl?: string;
  isOpen: boolean;
  onRequestClose: () => void;
}) {
  const [step, setStep] = useState<"crop" | "search">("crop");

  const [img, setImg] = useState<Blob | null>(null);

  const [filter, setFilter] = useState<FilterType>();
  const [s3Key, setS3Key] = useState("");

  const handleStartToSearchImg = async (img: Blob, s3Key: string) => {
    setStep("search");
    setS3Key(s3Key);
    setImg(img);
  };

  const handleBackToCropImg = () => {
    setStep("crop");
  };

  useEffect(() => {
    if (!isOpen) {
      setImg(null);
      setS3Key("");
      setStep("crop");
      setFilter(null);
    }
  }, [isOpen]);

  return (
    <APIProvider
      apiKey={"AIzaSyAqk45RIVytV7tiTjTy2UISpHEgSWjl1vg"}
      onLoad={() => console.log("Maps API has loaded.")}
    >
      {step === "crop" ? (
        <CropAlertImgForSearchModal
          title={title}
          defaultImgUrl={defaultImgUrl}
          isOpen={step === "crop" && isOpen}
          onRequestClose={onRequestClose}
          onFinish={handleStartToSearchImg}
          filter={filter}
          onFilterChange={(filter) => setFilter(filter)}
        />
      ) : (
        <ImgSearchModal
          filter={filter}
          s3Key={s3Key}
          img={img}
          isOpen={step === "search" && isOpen}
          onRequestClose={onRequestClose}
          handleBackToCropImg={handleBackToCropImg}
          onFilterChange={(filter) => setFilter(filter)}
        />
      )}
    </APIProvider>
  );
}
